import { render, staticRenderFns } from "./LakeTampier.vue?vue&type=template&id=5753fb74&scoped=true&"
import script from "./LakeTampier.vue?vue&type=script&lang=js&"
export * from "./LakeTampier.vue?vue&type=script&lang=js&"
import style0 from "./LakeTampier.vue?vue&type=style&index=0&id=5753fb74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5753fb74",
  null
  
)

export default component.exports